import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { queryClient } from './app/query-client'
import { router } from './app/router'
import { AuthProvider } from './features/auth/AuthProvider'
import { I18nProvider } from './features/i18n/I18nProvider'
import { NativeDeepLinkHandler } from './features/acquisition/NativeDeepLinkHandler'
import './styles/global.css'
import './styles/i18n.css'
import './styles/apple-quality.css'
import './styles/premium-experience.css'
import './styles/camera-finish-cta.css'

const root = document.getElementById('root')

if (!root) throw new Error('Application root element was not found.')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <I18nProvider>
          <NativeDeepLinkHandler />
          <RouterProvider router={router} />
        </I18nProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
